import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { DotChartOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useInterviews from '../useInterviews';
import { ResponsivePie } from '@nivo/pie';
import { usePdf } from '../../../../../hooks/usePdf';
import moment from 'moment';
import React from 'react';

const Answers = () => {
  const { answers, handleDownloadExcelSingle, loading } = useInterviews(
    false,
    false,
    true,
  );
  const { loadingPdf, handleDownloadPdfForInterview } = usePdf();
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('SONDAGGIO A RISPOSTA CHIUSA').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              iconMargin
              width={'138px'}
              icon={<FilePdfOutlined />}
              loading={loadingPdf}
              onClick={() =>
                handleDownloadPdfForInterview(
                  answers?.interview?.title || 'file',
                )
              }
            >
              {t('Stampa')}
            </Button>
          </Col>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              loading={loading}
              onClick={handleDownloadExcelSingle}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Row gutter={16}>
          <Col span={24}>
            <Typography.Title className={styles.title} level={4}>
              {answers?.interview?.shopping_center}
            </Typography.Title>
            <Typography.Title className={styles.title} level={4}>
              {answers?.interview?.title}
            </Typography.Title>
            <Typography.Title level={4} className={styles.title}>
              {moment(answers?.interview?.created_at).format('DD MMMM YYYY')}
            </Typography.Title>
          </Col>
          <Col span={24}>
            <Typography.Title level={4}>
              {t('Clienti che hanno risposto')}: {answers.answer_count}
            </Typography.Title>
          </Col>
          {answers?.interview_questions?.map((question) => {
            const data = question.chart.map((i) => ({
              id: i[0],
              label: i[0],
              value: i[1],
            }));
            return (
              <Col span={12} key={question.id}>
                <Row gutter={16}>
                  <Col span={24}>
                    <Typography.Title level={4}>
                      {question.title}
                    </Typography.Title>
                  </Col>
                  <Col span={24} className={styles.chart}>
                    <ResponsivePie
                      data={data}
                      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                      innerRadius={0.5}
                      padAngle={0.7}
                      cornerRadius={3}
                      activeOuterRadiusOffset={8}
                      colors={{ scheme: 'category10' }}
                      borderWidth={1}
                      borderColor={{
                        from: 'color',
                        modifiers: [['darker', 0.2]],
                      }}
                      arcLinkLabelsSkipAngle={10}
                      arcLinkLabelsTextColor='#333333'
                      arcLinkLabelsThickness={2}
                      arcLinkLabelsColor={{ from: 'color' }}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{
                        from: 'color',
                        modifiers: [['darker', 2]],
                      }}
                      defs={[
                        {
                          id: 'dots',
                          type: 'patternDots',
                          background: 'inherit',
                          color: 'rgba(255, 255, 255, 0.3)',
                          size: 4,
                          padding: 1,
                          stagger: true,
                        },
                        {
                          id: 'lines',
                          type: 'patternLines',
                          background: 'inherit',
                          color: 'rgba(255, 255, 255, 0.3)',
                          rotation: -45,
                          lineWidth: 6,
                          spacing: 10,
                        },
                      ]}
                      fill={[
                        {
                          match: {
                            id: 'ruby',
                          },
                          id: 'dots',
                        },
                        {
                          match: {
                            id: 'c',
                          },
                          id: 'dots',
                        },
                        {
                          match: {
                            id: 'go',
                          },
                          id: 'dots',
                        },
                        {
                          match: {
                            id: 'python',
                          },
                          id: 'dots',
                        },
                        {
                          match: {
                            id: 'scala',
                          },
                          id: 'lines',
                        },
                        {
                          match: {
                            id: 'lisp',
                          },
                          id: 'lines',
                        },
                        {
                          match: {
                            id: 'elixir',
                          },
                          id: 'lines',
                        },
                        {
                          match: {
                            id: 'javascript',
                          },
                          id: 'lines',
                        },
                      ]}
                      legends={[
                        {
                          anchor: 'bottom',
                          direction: 'row',
                          justify: false,
                          translateX: 0,
                          translateY: 56,
                          itemsSpacing: 0,
                          itemWidth: 180,
                          itemHeight: 18,
                          itemTextColor: '#999',
                          itemDirection: 'left-to-right',
                          itemOpacity: 1,
                          symbolSize: 18,
                          symbolShape: 'circle',
                          effects: [
                            {
                              on: 'hover',
                              style: {
                                itemTextColor: '#000',
                              },
                            },
                          ],
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};

export default Answers;
